var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.loading
      ? _c("div", [
          _c(
            "div",
            { staticClass: "text-center" },
            [
              _c("b-spinner", {
                attrs: {
                  small: "",
                  variant: "primary",
                  type: "grow",
                  label: "Spinning",
                },
              }),
              _vm._v(" "),
              _c("b-spinner", {
                attrs: {
                  small: "",
                  variant: "primary",
                  type: "grow",
                  label: "Spinning",
                },
              }),
              _vm._v(" "),
              _c("b-spinner", {
                attrs: {
                  small: "",
                  variant: "primary",
                  type: "grow",
                  label: "Spinning",
                },
              }),
            ],
            1
          ),
        ])
      : _c(
          "div",
          [
            _c(
              "b-button",
              {
                directives: [
                  {
                    name: "b-toggle",
                    rawName: "v-b-toggle",
                    value: "list-invisible-activities",
                    expression: "'list-invisible-activities'",
                  },
                ],
                staticClass: "m-1",
                attrs: { variant: "info" },
              },
              [
                _c(
                  "span",
                  { staticClass: "when-open" },
                  [
                    _c("font-awesome-icon", {
                      attrs: { icon: ["fas", "chevron-up"] },
                    }),
                    _vm._v(" "),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "when-closed" },
                  [
                    _c("font-awesome-icon", {
                      attrs: { icon: ["fas", "chevron-down"] },
                    }),
                    _vm._v(" "),
                  ],
                  1
                ),
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("label.list_external_activities")) +
                    "\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _c("b-collapse", { attrs: { id: "list-invisible-activities" } }, [
              _vm.activities != null && _vm.activities.length === 0
                ? _c(
                    "div",
                    [
                      _c(
                        "b-row",
                        { staticClass: "align-center" },
                        [
                          _c("b-col", [
                            _c("i", [
                              _vm._v(_vm._s(_vm.$t("label.no_activity"))),
                            ]),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "b-row",
                    { staticClass: "align-center mb-md-2" },
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "b-modal",
                                  rawName:
                                    "v-b-modal.modal-import-activities-list",
                                  modifiers: {
                                    "modal-import-activities-list": true,
                                  },
                                },
                              ],
                              attrs: { variant: "primary" },
                            },
                            [_vm._v(_vm._s(_vm.$t("btn.import")))]
                          ),
                          _vm._v(" "),
                          _vm.hasAdminConnector
                            ? _c(
                                "b-button",
                                {
                                  directives: [
                                    {
                                      name: "b-modal",
                                      rawName:
                                        "v-b-modal.modal-import-activities-list-from-lds",
                                      modifiers: {
                                        "modal-import-activities-list-from-lds": true,
                                      },
                                    },
                                  ],
                                  attrs: { variant: "primary" },
                                },
                                [_vm._v(_vm._s(_vm.$t("btn.import_lds")))]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-modal",
                        {
                          attrs: {
                            id: "modal-import-activities-list",
                            title: "Importer une liste d'activités",
                            scrollable: "",
                            "hide-footer": "",
                          },
                        },
                        [
                          _c("form-import-list", {
                            attrs: {
                              id: _vm.id,
                              "button-disabled":
                                _vm.isDisabledButtonImportActivity,
                            },
                            on: { sendForm: _vm.receiveForm },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-modal",
                        {
                          attrs: {
                            id: "modal-import-activities-list-from-lds",
                            title: "Importer une liste d'activités (LDS)",
                            scrollable: "",
                            "hide-footer": "",
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t("label.import_lds.explain_import")
                              ) +
                              "\n\n            "
                          ),
                          _c(
                            "b-alert",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.haveExternalIds,
                                  expression: "haveExternalIds",
                                },
                              ],
                              attrs: { show: "", variant: "warning" },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t("label.import_lds.warning_import")
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "text-center" },
                            [
                              _c(
                                "b-button",
                                {
                                  attrs: {
                                    variant: "success",
                                    disabled: _vm.loading,
                                  },
                                  on: { click: _vm.importFromLDS },
                                },
                                [_vm._v(_vm._s(_vm.$t("btn.import")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-button",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.$bvModal.hide(
                                        "modal-import-activities-list-from-lds"
                                      )
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("btn.cancel")))]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c("b-table", {
                        attrs: {
                          fields: _vm.fields,
                          items: _vm.activities,
                          small: "",
                          responsive: "",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "cell(color)",
                            fn: function (row) {
                              return [
                                _c("div", {
                                  staticClass: "square",
                                  style: { background: row.item.color },
                                }),
                              ]
                            },
                          },
                          {
                            key: "cell(cae_label)",
                            fn: function (row) {
                              return [
                                _c(
                                  "b-badge",
                                  {
                                    style: {
                                      backgroundColor: row.item.domain_color,
                                    },
                                  },
                                  [_vm._v(_vm._s(row.item.cae_label))]
                                ),
                              ]
                            },
                          },
                          {
                            key: "cell(icon_path)",
                            fn: function (row) {
                              return [
                                _c("div", {
                                  staticClass: "square-activity",
                                  style: {
                                    backgroundImage: `url(${_vm.getIconeImgNoExt(
                                      row.item.icon_path
                                    )})`,
                                    backgroundColor: row.item.color,
                                  },
                                }),
                              ]
                            },
                          },
                          {
                            key: "cell(cae_is_enable)",
                            fn: function (row) {
                              return [
                                _c(
                                  "b-badge",
                                  {
                                    attrs: {
                                      variant: row.item.cae_is_enable
                                        ? "success"
                                        : "danger",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          row.item.cae_is_enable
                                            ? "Actif"
                                            : "Inactif"
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                          {
                            key: "cell(update)",
                            fn: function (row) {
                              return [
                                _c(
                                  "b-col",
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        directives: [
                                          {
                                            name: "b-modal",
                                            rawName: "v-b-modal",
                                            value:
                                              "modal-update-activity-" +
                                              row.item.cae_id,
                                            expression:
                                              "'modal-update-activity-'+ row.item.cae_id",
                                          },
                                        ],
                                        attrs: {
                                          size: "sm",
                                          variant: "primary",
                                          disabled: "",
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("btn.update")))]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("b-modal", {
                                  attrs: {
                                    id:
                                      "modal-update-activity-" +
                                      row.item.cae_id,
                                    title: "Modifier une activité",
                                    scrollable: "",
                                    "hide-footer": "",
                                  },
                                }),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }